<template>
    <section class="page5">
        <div class="conteudo text-left">
            <div class="col1">
                <p
                    class="openSans text-huge text-bold text-white"
                    data-aos="flip-right"
                    data-aos-duration="1000"
                >
                    O que é a LGPD para o RH
                </p>
            </div>
            <div class="col2" data-aos="fade-up" data-aos-delay="400">
                <img src="~@/assets/img/page4-img.png" alt="" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page5 {
    background-image: url("~@/assets/img/section-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    // height: 768px;
    padding-top: 125px;
    padding-bottom: 125px;
    .col2 {
        img {
            max-width: 100%;
        }
    }

    @media (max-width: 1336px) {
        padding-left: 20px;
        padding-right: 20px;
    }
    @media (max-width: 900px) {
        padding-left: 20px;
        padding-right: 20px;
        .conteudo {
            max-width: 90%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .col2 {
                padding-top: 30px;
            }
        }
    }
}
</style> 